import type { SubComponentsReturnType } from '../../types';

import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';
import type { FacebookGroupPostComponentsProps } from './types';

// TODO: Implement actual components
export function useFacebookGroupPostComponents(props: FacebookGroupPostComponentsProps): SubComponentsReturnType {
	return {
		header: <Header {...props} />,
		body: <Body {...props} />,
		footer: <Footer {...props} />,
	};
}
